module.exports = __webpack_public_path__ + "img/bo.e6582f36.svg";